<template>
  <span class="avatar-initial" :class="`avatar-initial--${size}`">{{ letter }}</span>
</template>

<script>
export default {
  name: 'AvatarInitial',
  props: {
    name: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: 'md',
      validator: v => ['lg', 'md', 'sm'].includes(v),
    },
  },
  computed: {
    letter() {
      return this.name ? this.name.charAt(0).toUpperCase() : '';
    },
  },
};
</script>

<style scoped>
.avatar-initial {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #E6EEF6;
  color: #2C4A6B;
  font-family: Inter, sans-serif;
  font-weight: 500;
  flex-shrink: 0;
  line-height: 1;
}

[data-module="restaurant"] .avatar-initial {
  background: var(--sidebar-active-bg);
  color: var(--biz-text); /* 字母是文字：用深橙，不用填充橙 */
}

/* 品牌模式跟餐厅模式一样跟随侧边栏配色（浅绿底 + 深绿字）。只限侧边栏那一个：
   这个组件在评论/榜单/报表里也用，那些保持默认。 */
[data-module="brand"] .brandBoxWrap .avatar-initial {
  background: var(--sidebar-active-bg);
  color: var(--brand-primary);
}

/* lg — sidebar / entity */
.avatar-initial--lg {
  width: 40px;
  height: 40px;
  font-size: 16px;
  font-weight: 600;
}

/* md — table row */
.avatar-initial--md {
  width: 32px;
  height: 32px;
  font-size: 14px;
}

/* sm — comment / activity */
.avatar-initial--sm {
  width: 28px;
  height: 28px;
  font-size: 12px;
}
</style>
